import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

import * as styles from './CollectionActionModal.css';

export const ArchiveModal = ({
  isOpen,
  close,
  archive,
  isConfirming = false,
}: {
  isOpen: boolean;
  close: () => void;
  archive: () => void;
  isConfirming?: boolean;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    title="Archiving?"
    modalClassName="w-full md:w-[650px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        Archiving this product will hide it from your channel, so customers
        won’t see it or be able to purchase it. However, customers who have
        already bought it will still have access.
      </Typography>
      <Typography variant="body" size="large" fontWeight="normal">
        You can always restore it later if needed.
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={close}
          className={styles.actionButton}
        >
          Cancel
        </Button>
        <Button
          color="neutral"
          onClick={archive}
          className={styles.actionButton}
          disabled={isConfirming}
        >
          Yes, archive
        </Button>
      </div>
    </div>
  </Modal>
);
